module.exports = __webpack_public_path__ + "static/img/wxCode.d5bad24.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/wxCode.jpg
// module id = LEID
// module chunks = 18